<template>
    <DefaultTemplate>
        <div class="card rounded signup text-center">
            <p @click="$router.go(-1)" class="cr-pointer text-left">
                <b-icon
                    icon="arrow-left"
                    class="mg-less text-black"
                    size="is-small"
                    ></b-icon>
                <span class="text-black">ย้อนกลับ</span>
            </p>
            <h2>เพิ่มข้อมูลผู้ใช้</h2>
            <InputForm :editProfile="false" @saveData="saveData" />
        </div>
    </DefaultTemplate>    
</template>
<script>
import InputForm from '@/components/User/FormProfile'
import DefaultTemplate from '@/template/DefaultTemplate'
import { HTTP } from "@/service/axios.js";
export default {
    components:{
        DefaultTemplate,
        InputForm
    },
    methods:{
        async saveData(data){
            let user = data
            console.log('saveData',data);
            const config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            };
            let formData = new FormData();
           
            formData.append("userId", user._id);
            formData.append("name", user.name);
            formData.append("surname", user.surname);
            formData.append("department", user.department);
            formData.append("position", user.position);
            formData.append("profileImage", user.file);
            HTTP.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
            HTTP.post(`edit/profile`, formData, config).then(res=>{
                console.log('res',res);
                if(res.data.success){
                    this.$buefy.toast.open({
                        message: 'แก้ไขข้อมูลสำเร็จ',
                        type: 'is-success'
                    })
                    this.$store.commit('SET_USER',user)
                }else{

                }
            }).catch(e =>{ console.log('edit/profile error', e); })
            
            
            this.$router.go(-1)
        }
    }
}
</script>